/* vl-main-product: gallery, option pills → variant resolution,
   price/badge/button updates, qty, add-to-cart. Product data comes
   from an inline JSON script rendered by the section. */
(function () {
  'use strict';

  class VlMainProduct extends HTMLElement {
    connectedCallback() {
      var dataEl = this.querySelector('[data-vl-product-json]');
      if (!dataEl) return;
      this.product = JSON.parse(dataEl.textContent);
      this.moneyFormat = this.getAttribute('data-money-format') || '{{amount}} ₺';
      /* campaign numbers from the section (Theme settings → ViskoLove); the
         maths itself is in campaignPrice / couponFor / havalePrice below */
      this.camp = {
        mode: this.getAttribute('data-vl-camp-mode') || 'admin',
        pct: parseFloat(this.getAttribute('data-vl-camp-pct')) || 0,
        havalePct: parseFloat(this.getAttribute('data-vl-havale-pct')) || 0,
        rungs: (this.getAttribute('data-vl-coupon-rungs') || '').split(/[,\n]/).map(function (line) {
          var p = line.split(':');
          return p.length > 1 ? [parseFloat(p[0]) * 100, parseFloat(p[1]) * 100] : null;
        }).filter(function (r) { return r && r[0] > 0 && r[1] > 0; })
      };
      /* quantity combinations (pillows): discount % for 1, 2, 3… pieces, from
         the buy box. Empty on products without them (beds), where the price
         card keeps showing one piece whatever the quantity. */
      var tierHost = this.querySelector('[data-vl-tiers]');
      this.tiers = tierHost
        ? tierHost.getAttribute('data-vl-tiers').split(',').map(function (x) { return parseFloat(x); }).filter(function (x) { return !isNaN(x); })
        : [];
      this.qtyInput = this.querySelector('.vl-mp__qty input');
      /* % above the last amount (data-vl-tiers-above): the price list covers at
         most 4 sleep pillows, so 0 there; null keeps the last amount's % */
      var tiersAboveAttr = tierHost ? tierHost.getAttribute('data-vl-tiers-above') : null;
      this.tiersChip = tierHost ? (tierHost.getAttribute('data-vl-tiers-chip') || '') : '';   /* chip wording for 2+ pieces (owner 2026-10-17: "%25 + EK %15") */
      this.tiersAbove = tiersAboveAttr !== null && tiersAboveAttr !== '' && !isNaN(parseFloat(tiersAboveAttr)) ? parseFloat(tiersAboveAttr) : null;
      /* list prices the page strikes through, per variant id in cents, from
         snippets/vl-camp.liquid 'list': the admin compare-at price, or on a
         preview theme the List prices theme setting when admin has none */
      try { this.lists = JSON.parse(this.getAttribute('data-vl-list-prices') || '{}') || {}; } catch (e) { this.lists = {}; }
      /* gift pillow (beds): how many pillows a bed width brings, the gift
         variant, and the labels its cart line carries. Null on other products. */
      /* "birlikte alın" companions (2026-10-13, 23 Sept meeting): a tick puts the row's product into the cart AT ONCE (owner,
         the same evening: "when the user select suggested product it should be added directly to the basket too") and an
         untick takes that line out; the bed row adds the bed's cheapest size with its gift pillow, as the bed page does. Rows
         whose line is already in the cart come up ticked, and follow the cart (a line removed in the drawer unticks). */
      this.addonRows = Array.prototype.slice.call(this.querySelectorAll('[data-vl-addon]'));
      this.addonRows.forEach(function (row) {
        var cb = row.querySelector('input[type="checkbox"]'); if (!cb) return;
        cb.addEventListener('change', function () { self.addonToggle(row, cb); });
      });
      if (this.addonRows.length) {
        this.syncAddons();
        var syncTimer = 0, resync = function () { clearTimeout(syncTimer); syncTimer = setTimeout(function () { self.syncAddons(); }, 500); };
        ['cart:update', 'cart:reload', 'cart:refresh'].forEach(function (n) { document.addEventListener(n, resync); });
      }
      var giftEl = this.querySelector('[data-vl-gift]');
      this.gift = giftEl ? {
        el: giftEl,
        variant: parseInt(giftEl.dataset.giftVariant, 10),
        unit: parseInt(giftEl.dataset.giftUnit, 10) || 0,
        min: parseFloat(giftEl.dataset.giftMin) || 160,
        small: parseInt(giftEl.dataset.giftSmall, 10) || 1,
        large: parseInt(giftEl.dataset.giftLarge, 10) || 2,
        prop: giftEl.dataset.giftProp || 'Hediye',
        propValue: giftEl.dataset.giftPropValue || ''
      } : null;
      this.selected = {};
      var self = this;

      /* initial selected options from the first available variant */
      var first = this.product.variants.find(function (v) { return v.available; }) || this.product.variants[0];
      if (first) first.options.forEach(function (val, i) { self.selected[i] = val; });

      /* gallery */
      this.mainImg = this.querySelector('.vl-mp__main img');
      var thumbs = Array.prototype.slice.call(this.querySelectorAll('.vl-mp__thumb'));
      var showThumb = function (t) {
        if (!t) return;
        thumbs.forEach(function (x) { x.classList.remove('active'); });
        t.classList.add('active');
        if (self.mainImg && t.dataset.src) {
          if (t.dataset.srcset) self.mainImg.setAttribute('srcset', t.dataset.srcset);
          else self.mainImg.removeAttribute('srcset');
          self.mainImg.src = t.dataset.src;
        }
        /* keep the active thumb visible WITHOUT scrolling the page */
        var strip = t.parentElement;
        if (strip && strip.scrollWidth > strip.clientWidth + 1) {
          var left = t.offsetLeft - (strip.clientWidth - t.offsetWidth) / 2;
          if (strip.scrollTo) strip.scrollTo({ left: Math.max(0, left), behavior: 'smooth' });
          else strip.scrollLeft = Math.max(0, left);
        }
      };
      thumbs.forEach(function (t) { t.addEventListener('click', function () { showThumb(t); }); });
      /* side arrows — wrap around the gallery */
      this.querySelectorAll('[data-vl-gal]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (!thumbs.length) return;
          var cur = thumbs.findIndex(function (x) { return x.classList.contains('active'); });
          if (cur < 0) cur = 0;
          var step = parseInt(btn.dataset.vlGal, 10) || 1;
          showThumb(thumbs[(cur + step + thumbs.length) % thumbs.length]);
        });
      });

      /* size pills — on products with combinations, a size means one piece */
      this.querySelectorAll('.vl-mp__pill[data-option-index]').forEach(function (p) {
        p.addEventListener('click', function () {
          self.selected[parseInt(p.dataset.optionIndex, 10)] = p.dataset.value;
          if (self.tiers.length && self.qtyInput) self.qtyInput.value = 1;
          self.paintPills();
          self.applyVariant();
        });
      });

      /* combination pills (2 x M, 3 x L …) — that size, that many pieces */
      this.querySelectorAll('[data-vl-combo]').forEach(function (p) {
        p.addEventListener('click', function () {
          var cv = self.product.variants.find(function (x) { return String(x.id) === p.dataset.variantId; });
          if (!cv) return;
          cv.options.forEach(function (val, i) { self.selected[i] = val; });
          if (self.qtyInput) self.qtyInput.value = parseInt(p.dataset.qty, 10) || 1;
          self.paintPills();
          self.applyVariant();
        });
      });

      /* gift card "i" — shows or hides the gift explanation under the card */
      var giftInfo = this.querySelector('.vl-mp__gift-info');
      if (giftInfo) {
        giftInfo.addEventListener('click', function () {
          var note = document.getElementById(giftInfo.getAttribute('aria-controls'));
          var open = giftInfo.getAttribute('aria-expanded') === 'true';
          giftInfo.setAttribute('aria-expanded', open ? 'false' : 'true');
          if (note) note.hidden = open;
        });
      }

      /* qty — with combinations, the price card and the pills follow it */
      var qtyInput = this.qtyInput;
      this.querySelectorAll('.vl-mp__qty button').forEach(function (b) {
        b.addEventListener('click', function () {
          var v = Math.max(1, (parseInt(qtyInput.value, 10) || 1) + parseInt(b.dataset.step, 10));
          qtyInput.value = v;
          if (self.tiers.length) { self.paintPills(); self.applyVariant(); }
        });
      });

      /* buy now — straight to checkout with the selected variant + qty, and the
         gift pillows when the product brings them (a cart permalink cannot
         carry line properties, so that gift line is unlabelled) */
      var buynow = this.querySelector('[data-vl-buynow]');
      /* the bed plus its gift pillow line, exactly as "Sepete Ekle" posts them (2026-09-17:
         buy-now and the havale button used a cart permalink, which cannot carry the gift's
         properties — the pillow never reached the checkout) */
      var linesFor = function (variant, q) {
        var items = [{ id: variant.id, quantity: q }];
        var giftItem = self.giftItem ? self.giftItem(variant, q) : null;
        if (giftItem) items.push(giftItem);
        self.addonItems().forEach(function (it) { items.push(it); });
        return items;
      };
      var postLines = function (list) {
        return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: list }) })
          .then(function (r) { if (!r.ok) throw 0; return r.json(); });
      };
      if (buynow) {
        buynow.addEventListener('click', function () {
          var variant = self.currentVariant();
          if (!variant || !variant.available) return;
          /* 2026-11-04: the acceptance box above the button (snippets/vl-terms-box) must be ticked; after the add the
             tick is recorded on the cart (assets/vl-terms.js) and only then the checkout opens */
          if (window.vlTerms && !window.vlTerms.check(self)) return;
          var q = parseInt(qtyInput ? qtyInput.value : 1, 10) || 1;
          var items = linesFor(variant, q);
          buynow.disabled = true;
          postLines(items)
            .catch(function () { if (items.length > 1) return postLines(items.slice(0, 1)); throw 0; })
            .then(function () { return window.vlTerms ? window.vlTerms.record('buynow').catch(function () {}) : null; })
            .then(function () { window.location.href = '/checkout'; })
            .catch(function () { buynow.disabled = false; window.location.href = '/cart/' + variant.id + ':' + q + self.giftPermalink(variant, q); });
        });
      }

      /* havale — adds the selected variant, switches the cart to Havale/EFT mode
         (attribute + code) and goes to checkout; see assets/vl-havale.js */
      var havale = this.querySelector('[data-vl-havale][data-vl-havale-context="product"]');
      if (havale) {
        havale.addEventListener('click', function () {
          var variant = self.currentVariant();
          if (!variant || !variant.available) return;
          var qty = parseInt(qtyInput ? qtyInput.value : 1, 10) || 1;
          var attr = havale.getAttribute('data-vl-havale-attr') || 'havale';
          var code = havale.getAttribute('data-vl-havale-code') || '';
          if (window.vlHavale && window.vlHavale.buyItems) { window.vlHavale.buyItems(linesFor(variant, qty), attr, code); return; }
          if (window.vlHavale) { window.vlHavale.buy(variant.id, qty, attr, code); return; }
          /* fallback when vl-havale.js has not loaded: permalink carrying attribute + code */
          var url = '/cart/' + variant.id + ':' + qty + (self.giftPermalink ? self.giftPermalink(variant, qty) : '') + '?attributes[odeme_yontemi]=' + encodeURIComponent(attr);
          if (code) url += '&discount=' + encodeURIComponent(code);
          window.location.href = url;
        });
      }

      /* campaign countdown.
         [data-vl-countdown-end="YYYY-MM-DD HH:MM"] counts down to one fixed
         moment for everyone (Türkiye time, UTC+3 all year round) and fills the
         days box when the markup has one. Without it, [data-vl-countdown="hours"]
         keeps the rolling per-visitor window: the deadline is stored, not the
         remaining seconds, so it keeps running while the shopper moves between
         products instead of restarting on every page load. Keyed by the window
         length so changing the setting in the editor starts a fresh countdown
         rather than inheriting a stale one. */
      this.querySelectorAll('[data-vl-countdown]').forEach(function (box) {
        var segs = Array.prototype.slice.call(box.querySelectorAll('.vl-mp__seg'));
        if (segs.length < 3) return;
        var byName = function (name, idx) { return box.querySelector('.vl-mp__seg[data-seg="' + name + '"]') || segs[idx]; };
        var segD = box.querySelector('.vl-mp__seg[data-seg="d"]');
        var segH = byName('h', 0), segM = byName('m', 1), segS = byName('s', 2);
        var pad = function (n) { return ('0' + n).slice(-2); };
        var paint = function (left) {
          left = Math.max(0, left);
          if (segD) { segD.textContent = String(Math.floor(left / 86400)); left = left % 86400; }
          segH.textContent = pad(Math.floor(left / 3600));
          segM.textContent = pad(Math.floor((left % 3600) / 60));
          segS.textContent = pad(left % 60);
        };
        var fixedMatch = (box.dataset.vlCountdownEnd || '').match(/^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2})/);
        if (fixedMatch) {
          var fixedEnd = Date.UTC(+fixedMatch[1], +fixedMatch[2] - 1, +fixedMatch[3], +fixedMatch[4] - 3, +fixedMatch[5]);
          var fixedTimer = null;
          var tickFixed = function () {
            paint(Math.floor((fixedEnd - Date.now()) / 1000));
            if (fixedEnd <= Date.now() && fixedTimer) clearInterval(fixedTimer);
          };
          tickFixed();
          fixedTimer = setInterval(tickFixed, 1000);
          return;
        }
        var hours = parseFloat(box.dataset.vlCountdown) || 2;
        var span = Math.round(hours * 3600) * 1000;
        var key = 'vlCampaignEnds_' + hours;
        var memo = null;                       /* fallback when storage is blocked */
        var read = function () {
          try { return parseInt(localStorage.getItem(key), 10); } catch (e) { return memo; }
        };
        var write = function (v) {
          memo = v;
          try { localStorage.setItem(key, String(v)); } catch (e) {}
        };
        var deadline = function () {
          var now = Date.now();
          var end = read();
          /* start a window when there is none, when it has run out, or when a
             stored one is longer than the current setting allows */
          if (!end || isNaN(end) || end <= now || end > now + span) {
            end = now + span;
            write(end);
          }
          return end;
        };
        var end = deadline();
        var tick = function () {
          var left = Math.floor((end - Date.now()) / 1000);
          if (left < 0) { end = deadline(); left = Math.floor((end - Date.now()) / 1000); }
          paint(left);
        };
        tick();
        setInterval(tick, 1000);
        /* a tab restored from bfcache or unhidden has a stale reading */
        document.addEventListener('visibilitychange', function () {
          if (!document.hidden) { end = deadline(); tick(); }
        });
      });

      /* add to cart — the bed and its gift pillows go in one request, so the
         cart never holds one without the other. If the gift cannot be added
         (sold out, removed), the product is added on its own. */
      var atc = this.querySelector('.vl-mp__atc');
      if (atc) {
        atc.addEventListener('click', function () {
          var variant = self.currentVariant();
          if (!variant || !variant.available || atc.dataset.busy) return;
          atc.dataset.busy = '1';
          /* only the text span swaps, so the cart icon survives the busy state */
          var labelEl = atc.querySelector('.vl-mp__atc-txt') || atc;
          var label = labelEl.innerHTML;
          labelEl.textContent = 'Ekleniyor...';
          var q = parseInt(qtyInput ? qtyInput.value : 1, 10) || 1;
          var items = [{ id: variant.id, quantity: q }];
          var giftItem = self.giftItem(variant, q);
          if (giftItem) items.push(giftItem);
          self.addonItems().forEach(function (it) { items.push(it); });
          /* 2026-10-16 (owner's brief, the side cart gone): the pop-up of assets/vl-added.js opens at once in its "adding" state and
             then shows the line (with the gift pillow line and a stepper); without it (setting off) the old toast answers.
             A failed add shows Shopify's reason inside the pop-up instead of leaving the page. */
          var va = window.vlAdded || null;
          var meta = { opener: atc, variant: variant.id, image: self.mainImg ? (self.mainImg.currentSrc || self.mainImg.src) : '', title: self.product.title, list: self.listPrice(variant) };
          if (va) va.begin(meta);
          var post = function (list) {
            return fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ items: list })
            }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }, function () { if (!r.ok) throw 0; return {}; }); });
          };
          post(items)
            .catch(function (err) { if (items.length > 1) return post(items.slice(0, 1)); throw err; })
            .then(function (resp) {
              delete atc.dataset.busy;
              labelEl.innerHTML = label;
              self.addonsAdded(items);
              if (va) va.done(resp, meta);
              else { var t = document.querySelector('.vl-mp-toast'); if (t) { t.classList.add('show'); setTimeout(function () { t.classList.remove('show'); }, 2400); } }
              fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
                document.querySelectorAll('hdt-cart-count, .cart-count, .cart-count-bubble span, [data-cart-count]').forEach(function (el) { el.textContent = c.item_count; });
                document.dispatchEvent(new CustomEvent('cart:count:update', { detail: { item_count: c.item_count } }));
              }).catch(function () {});
              document.dispatchEvent(new CustomEvent('cart:reload'));
            })
            .catch(function (err) {
              delete atc.dataset.busy;
              labelEl.innerHTML = label;
              if (va) { va.fail(err && (err.description || err.message) ? err : ''); return; }
              var v2 = self.currentVariant();
              if (v2) window.location.href = '/cart/add?id=' + v2.id + '&quantity=' + q;
            });
        });
      }

      this.paintPills();
      this.applyVariant();
    }

    currentVariant() {
      var self = this;
      return this.product.variants.find(function (v) {
        return v.options.every(function (val, i) { return self.selected[i] === val; });
      }) || null;
    }

    qty() {
      return this.qtyInput ? Math.max(1, parseInt(this.qtyInput.value, 10) || 1) : 1;
    }

    money(cents) {
      var amount = (cents / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      return this.moneyFormat.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, amount);
    }

    /* same as money() but with the ".00" tail stripped — mirrors the Liquid
       money_without_trailing_zeros used for the savings chip, which keeps
       real cents (8,150.50) and drops only zero cents */
    moneyShort(cents) {
      var amount = (cents / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace(/\.00$/, '');
      return this.moneyFormat.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, amount);
    }

    /* campaign maths, the same rules as snippets/vl-camp.liquid, so the Liquid
       render of the first variant and this script's repaint of the others
       agree to the kuruş. Source: the Eylül 2026 price list (owner,
       2026-09-15). Preview mode: shown price = list × (1 − campaign %), exact,
       no coupon taken off. Admin mode: the admin price. Havale = shown price
       × (1 − havale %), exact. */
    listPrice(v) {
      var l = this.lists && this.lists[v.id];
      if (l) return l;
      return v.compare_at_price > v.price ? v.compare_at_price : 0;
    }
    campaignPrice(v) {
      var list = this.listPrice(v);
      if (this.camp.mode !== 'preview' || !list) return v.price;
      return Math.round(list * (100 - this.camp.pct) / 100);
    }
    couponFor(cents) {
      return this.camp.rungs.reduce(function (best, r) { return cents >= r[0] && r[1] > best ? r[1] : best; }, 0);
    }
    havalePrice(cents) {
      return Math.round(cents * (100 - this.camp.havalePct) / 100);
    }

    /* price of the selected size × amount. Without combinations the card shows
       one piece. With them, one piece is the campaign price and n pieces are
       the list price × n less that amount's %, exact: the price list's Sepet
       Tutarı. Above the last amount the data-vl-tiers-above % applies (0 for
       sleep pillows: the campaign covers at most 4), else the last amount's %. */
    linePrice(v, q) {
      if (!this.tiers.length) return this.campaignPrice(v);
      var list = this.listPrice(v);
      if (!list) return v.price * q;
      if (q <= 1) return this.campaignPrice(v);
      return Math.round(list * q * (100 - this.discountPct(q)) / 100);
    }

    /* the rate the chip and badge show: the campaign %, or the amount's % on
       products with combinations (the tiers-above % past the last amount) */
    discountPct(q) {
      if (!this.tiers.length) return this.camp.pct;
      if (q > this.tiers.length && this.tiersAbove !== null) return this.tiersAbove;
      return this.tiers[Math.min(Math.max(q, 1), this.tiers.length) - 1];
    }

    /* gift pillows per bed: the width is the number before the "x" in the
       size (160x200 → 160); from gift min width up the larger count applies */
    giftCount(v) {
      if (!this.gift || !v) return 0;
      var w = parseFloat(String(v.options[0] || v.title || '').split('x')[0]);
      if (isNaN(w)) return this.gift.small;
      return w >= this.gift.min ? this.gift.large : this.gift.small;
    }
    /* the gift cart line: visible label for the shopper and the warehouse,
       plus the hidden link to its bed that assets/vl-gift.js reconciles on */
    track(t, meta) { try { if (window.vlTrack) window.vlTrack.send(t, meta || {}); } catch (e) {} }
    /* the ticked companions are ALREADY in the cart (a tick adds at once since the evening of 2026-10-13), so "Sepete Ekle",
       buy-now and the havale path add nothing for them; kept because those paths call it */
    addonItems() { return []; }
    /* a tick → the row's lines go in; an untick → that line comes out. A busy row ignores a second tap; a failed call puts
       the box back the way it was. */
    addonToggle(row, cb) {
      var self = this, handle = row.getAttribute('data-handle') || '', on = cb.checked;
      if (row.getAttribute('data-busy') === '1') { cb.checked = !on; return; }
      row.setAttribute('data-busy', '1'); cb.disabled = true; row.classList.toggle('is-on', on);
      (on ? self.addonAdd(row) : self.addonRemove(row)).then(function () {
        row.removeAttribute('data-busy'); cb.disabled = false; self.paintAddonsTotal();
        if (on) self.track('addon_add', { handle: handle });
        self.cartChanged(on);
      }).catch(function () {
        row.removeAttribute('data-busy'); cb.disabled = false; cb.checked = !on; row.classList.toggle('is-on', !on); self.paintAddonsTotal();
      });
    }
    /* the row's cart lines: the product with the hidden property that names the page it came from and, for the bed row, the
       gift pillow line exactly as the bed page builds it (visible label + _vl_gift_for / _vl_gift_per for assets/vl-gift.js) */
    addonLines(row) {
      var id = parseInt(row.getAttribute('data-variant'), 10); if (!id) return [];
      var items = [{ id: id, quantity: 1, properties: { _vl_addon_for: this.product ? this.product.handle : '' } }];
      var gv = parseInt(row.getAttribute('data-gift-variant'), 10), per = parseInt(row.getAttribute('data-gift-per'), 10) || 0;
      if (gv && per) {
        var props = {}, prop = row.getAttribute('data-gift-prop'), val = row.getAttribute('data-gift-value');
        if (prop && val) props[prop] = val;
        props._vl_gift_for = String(id); props._vl_gift_per = String(per);
        items.push({ id: gv, quantity: per, properties: props });
      }
      return items;
    }
    addonAdd(row) {
      var items = this.addonLines(row); if (!items.length) return Promise.reject(0);
      var post = function (list) {
        return fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: list }) })
          .then(function (r) { if (!r.ok) throw 0; return r.json(); });
      };
      /* the bed goes in alone when its gift cannot be added (sold out), as on the bed page */
      return post(items).catch(function () { if (items.length > 1) return post(items.slice(0, 1)); throw 0; });
    }
    addonRemove(row) {
      var id = String(row.getAttribute('data-variant')), handle = this.product ? this.product.handle : '';
      return fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' }).then(function (r) { return r.json(); }).then(function (cart) {
        var line = (cart.items || []).filter(function (it) { return String(it.variant_id) === id && it.properties && it.properties._vl_addon_for === handle; })[0];
        if (!line) return null;   /* already gone (removed in the drawer) */
        return fetch('/cart/change.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: line.key, quantity: 0 }) })
          .then(function (r) { if (!r.ok) throw 0; return r.json(); });
      });
    }
    /* the rows follow the cart: a row whose line is in the cart is ticked (page load, a return to the page, a line removed in
       the drawer) */
    syncAddons() {
      var self = this, handle = this.product ? this.product.handle : '';
      fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' }).then(function (r) { return r.json(); }).then(function (cart) {
        var inCart = {}; (cart.items || []).forEach(function (it) { if (it.properties && it.properties._vl_addon_for === handle) inCart[String(it.variant_id)] = 1; });
        /* 2026-10-17: the header count follows too — an unticked bed loses its gift pillow a moment later (vl-gift.js, which
           announces it with cart:reload), and the count painted at the untick was one too high until the next page load */
        document.querySelectorAll('hdt-cart-count, .cart-count, .cart-count-bubble span, [data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
        (self.addonRows || []).forEach(function (row) {
          var cb = row.querySelector('input[type="checkbox"]'); if (!cb || row.getAttribute('data-busy') === '1') return;
          var on = !!inCart[row.getAttribute('data-variant')]; cb.checked = on; row.classList.toggle('is-on', on);
        });
        self.paintAddonsTotal();
      }).catch(function () {});
    }
    /* after a cart change from a row: the toast (adds only), the header count, the theme's cart:reload (drawer, cart
       suggestions, the gift script) */
    cartChanged(toast) {
      if (toast) { var t = document.querySelector('.vl-mp-toast'); if (t) { t.classList.add('show'); setTimeout(function () { t.classList.remove('show'); }, 2400); } }
      fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' }).then(function (r) { return r.json(); }).then(function (c) {
        document.querySelectorAll('hdt-cart-count, .cart-count, .cart-count-bubble span, [data-cart-count]').forEach(function (el) { el.textContent = c.item_count; });
        document.dispatchEvent(new CustomEvent('cart:count:update', { detail: { item_count: c.item_count } }));
      }).catch(function () {});
      try { document.dispatchEvent(new CustomEvent('cart:reload')); } catch (e) {}
    }
    /* the line under the rows: the product (chosen size × quantity) plus the ticked companions (owner, 2026-10-13: name the
       total the shopper would pay with the recommended product) */
    paintAddonsTotal() {
      var el = this.querySelector('[data-vl-addons-total]'); if (!el) return;
      var sum = 0; (this.addonRows || []).forEach(function (row) { var cb = row.querySelector('input[type="checkbox"]'); if (cb && cb.checked) sum += parseInt(row.getAttribute('data-price'), 10) || 0; });
      if (!sum) { el.hidden = true; return; }
      var v = this.currentVariant(); var q = parseInt(this.qtyInput ? this.qtyInput.value : 1, 10) || 1;
      var base = v ? (this.linePrice ? this.linePrice(v, q) : v.price * q) : 0;
      var tpl = el.getAttribute('data-tpl') || '{toplam}', self = this;
      el.textContent = tpl.replace(/\{(\w+)\}/g, function (m, k) { return k === 'toplam' ? self.moneyShort(base + sum) : (k === 'fark' ? '+' + self.moneyShort(sum) : m); });
      el.hidden = false;
    }
    /* after "Sepete Ekle": nothing to do for the companions any more — they went in at the tick and stay ticked (they are in
       the basket); the beacon addon_add is sent at the tick */
    addonsAdded() {}
    giftItem(v, q) {
      var n = this.giftCount(v);
      if (!n) return null;
      var props = {};
      if (this.gift.propValue) props[this.gift.prop] = this.gift.propValue;
      props._vl_gift_for = String(v.id);
      props._vl_gift_per = String(n);
      return { id: this.gift.variant, quantity: n * q, properties: props };
    }
    giftPermalink(v, q) {
      var n = this.giftCount(v);
      return n ? ',' + this.gift.variant + ':' + (n * q) : '';
    }
    paintGift(v) {
      if (!this.gift || !v) return;
      var n = this.giftCount(v);
      var sub = this.gift.el.querySelector('[data-vl-gift-sub]');
      if (sub && sub.dataset.tpl) sub.textContent = sub.dataset.tpl.replace('{count}', n).replace('{size}', sub.dataset.size || '');
      var qty = this.gift.el.querySelector('[data-vl-gift-qty]');
      if (qty && qty.dataset.tpl) qty.textContent = qty.dataset.tpl.replace('{count}', n);
      var pr = this.gift.el.querySelector('[data-vl-gift-price]');
      if (pr) pr.textContent = this.moneyShort(this.gift.unit * n);
    }

    paintPills() {
      var self = this;
      var v = this.currentVariant();
      var q = this.qty();
      var comboOn = false;
      this.querySelectorAll('[data-vl-combo]').forEach(function (p) {
        var on = !!v && String(v.id) === p.dataset.variantId && parseInt(p.dataset.qty, 10) === q;
        if (on) comboOn = true;
        p.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      /* a size pill reads as chosen unless a combination pill already does */
      this.querySelectorAll('.vl-mp__pill[data-option-index]').forEach(function (p) {
        var on = !comboOn && self.selected[parseInt(p.dataset.optionIndex, 10)] === p.dataset.value;
        p.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }

    applyVariant() {
      var v = this.currentVariant();
      var priceEl = this.querySelector('.vl-mp__price');
      var wasEl = this.querySelector('.vl-mp__price--was');
      var chipEl = this.querySelector('.vl-mp__sale-chip');
      var atc = this.querySelector('.vl-mp__atc');
      var atcTxt = atc ? (atc.querySelector('.vl-mp__atc-txt') || atc) : null;
      var buynow = this.querySelector('[data-vl-buynow]');
      var badge = this.querySelector('.vl-mp__badge');
      if (!v) {
        if (atc) { atc.disabled = true; atcTxt.textContent = atc.dataset.labelUnavailable || 'Mevcut Değil'; }
        if (buynow) buynow.disabled = true;
        return;
      }
      var q = this.tiers.length ? this.qty() : 1;
      var price = this.linePrice(v, q);
      var listCents = this.listPrice(v);
      var was = listCents ? listCents * q : 0;
      if (priceEl) priceEl.textContent = this.money(price);
      this.paintAddonsTotal();
      var onSale = was > price;
      if (wasEl) { wasEl.textContent = onSale ? this.money(was) : ''; wasEl.style.display = onSale ? '' : 'none'; }
      var pct = onSale ? (this.discountPct(q) || Math.round((1 - price / was) * 100)) : 0;
      pct = Math.round(pct);                       /* a stacked tier (25 + 15 → 36,25) prints as a whole number */
      if (chipEl) {
        var chipMode = chipEl.dataset.chipMode;
        chipEl.textContent = (q >= 2 && this.tiersChip) ? this.tiersChip
          : chipMode === 'percent' ? '- %' + pct
          : chipMode === 'net' ? (chipEl.dataset.chipNet || 'NET %{pct} İNDİRİM').replace('{pct}', pct)
          : this.moneyShort(was - price) + ' ' + (chipEl.dataset.chipSuffix || 'tasarruf');
        chipEl.style.display = onSale ? '' : 'none';
      }
      if (badge) { badge.textContent = '- %' + pct; badge.style.display = onSale ? '' : 'none'; }
      if (atc) {
        if (!v.available) { atc.disabled = true; atcTxt.textContent = atc.dataset.labelSoldout || 'Tükendi'; }
        else {
          atc.disabled = false;
          atcTxt.innerHTML = (atc.dataset.labelAdd || 'SEPETE EKLE') +
            (atc.dataset.showPrice === '1' ? '&nbsp;-&nbsp;' + this.money(price) : '');
        }
      }
      if (buynow) buynow.disabled = !v.available;
      /* installment line — price ÷ months. The snippet's own text scraper only
         finds a price when it is printed inside the add-to-cart button, so the
         amount is written here on every variant change. */
      var inst = document.querySelector('[data-visko-installment]');
      if (inst) {
        var months = parseInt(inst.getAttribute('data-visko-installment-months'), 10) || 9;
        var amt = inst.querySelector('[data-visko-installment-amount]');
        if (amt) amt.textContent = (price / 100 / months).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      }
      /* havale box — the bank-transfer price of the shown price */
      var hv = this.querySelector('[data-vl-havale-price]');
      if (hv) hv.textContent = this.moneyShort(this.havalePrice(price));
      var hvNote = this.querySelector('[data-vl-havale-note]');
      if (hvNote) {
        var cp = this.couponFor(price);
        hvNote.style.display = cp > 0 ? '' : 'none';
        if (hvNote.dataset.tpl) hvNote.textContent = hvNote.dataset.tpl.replace('{coupon}', this.moneyShort(cp));
      }
      this.paintGift(v);
      if (v.featured_image && v.featured_image.src && this.mainImg) {
        this.mainImg.removeAttribute('srcset');
        this.mainImg.src = v.featured_image.src;
      }
      this.paintPills();
    }
  }
  if (!customElements.get('vl-main-product')) customElements.define('vl-main-product', VlMainProduct);
})();
